import axios from "axios";
import { cartData, CustomerAddress ,  AddressData} from "../../models/cartData";
import { getAPI, getAPICart, getAPIData, postAPI, getAPIV2 } from "../remote/api_provider";




// Get API  function
export const getCartV2 = async (VCart: string) => {
  let response: cartData | any;
  response = await getAPICart(VCart);
  if(response.status === true){
  const { cart } = response.data || [];
  return cart;
  }else {
    return response;
  }
  
};


export const getCart = async (VCart: string) => {
  let response: cartData | any;
  response = await getAPIV2(VCart);
  if(response.status === true){
  const { cart } = response.data || [];
  return cart;
  }else {
    return response;
  }

};




// Get API function without payload

export const getDATA = async (VCart: string) => {
  let response: CustomerAddress;
  response = await getAPIData(VCart);
  const { addresses } = response.data || [];
  return addresses;
};



// get API function without payload and for any response
export const getResponse = async (VCart: string) => {
  let response: any;
  response = await getAPIData(VCart);
   response  = response.data || [];
  return response;
};



// post api

export const cartOperations = async (VCart: string, payload: any) => {
  let response: cartData | any;
  response = await postAPI(VCart, payload);
  if(response.status === true){
  const { cart } = response.data || [];
  return cart;
  } else {
    return response;
  }
};


// post API will return any type of response 
export const fetchAPIData = async (VCart: string, payload: any) => {
  let response:  any;
  response = await postAPI(VCart, payload);
  return response;
};





